import { makeFetcherBuilder } from '../base';
import { TENANT_API_URL } from '../../../constants';

export const makeFetcher = makeFetcherBuilder(TENANT_API_URL);
